<div class="dropdown-block" [ngClass]="{'opened': opened}">
    <div class="title" (click)="opened = !opened; changeSvgWidth()">
        <span>{{'__COACH_GROUPS_SELECT_PLACEHOLDER__' | translate}}</span>
<!--        <img *ngIf="!opened" src="assets/img/arrow-down.svg"  alt="">-->
<!--        <img *ngIf="opened" src="assets/img/arrow-up.svg" alt="">-->
        <div *ngIf="!opened" class="arrow-down"></div>
        <div *ngIf="opened" class="arrow-up"></div>
    </div>

    <div [ngClass]="{hidden: !opened}"  class="groups-container">
        <div (click)="item.selected = !item.selected" *ngFor="let item of items" class="item">
            <ion-checkbox checked="{{item.selected}}"></ion-checkbox>
            <span>{{item.name}} ({{item.count}})</span>
        </div>
<!--        <button class="button" type="submit" (click)="onSubmit()">Search</button>-->
    </div>

</div>
